import type { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';

import { MoplaRideTypesDrawer } from '@mopla/ui';

import { Root } from './styled';

const isNativePlatform = Capacitor.isNativePlatform();

export const RootPage: FC = () => {
	return (
		<Root elevation={isNativePlatform ? 0 : 2} square>
			<Outlet />
			{/*MoplaRideTypesDrawer should be able to render under any app's url, both for authenticated and unauthenticated users*/}
			<MoplaRideTypesDrawer />
		</Root>
	);
};
